<ng-template let-selectableData #accountCardCarouselTmplt [appControlTemplate]="'accountCardCarouselTmplt'">
    <box class="card-body">
        <box class="card-primary-info">
            <box class="logo"></box>
            <box class="card-reference-details">
                <h3>4019 XXXX XXXX 1110</h3>
                <box class="card-type">
                    <span class="card-type-name">Silver Card</span>
                    <span class="card-type-logo">IMG</span>
                </box>
            </box>
        </box>
        <box class="card-secondary-info">
            <box class="">1</box>
            <box class="">:</box>
            <box class="">2</box>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #debitSummaryCardTmplt [appControlTemplate]="'debitSummaryCardTmplt'">
    <box class="card-body debit-card-body">
        <span class="card-category">Debit</span>
        <box class="card-primary-info">
            <box class="logo">
                <img src="./assets/images/icons/credit-card.svg" alt="debit-card" />
            </box>
            <box class="card-reference-details">
                <h3>{{ selectableData.cardNumber }}</h3>
                <box class="card-type">
                    <span class="card-type-name">{{ selectableData.productDesc }}</span>
                    <span class="card-type-logo">
                        <img src="./assets/images/cards-logo/{{ selectableData?.cardType.toLocaleLowerCase() }}.svg"
                            alt="{{ selectableData?.cardType }}" />
                    </span>
                </box>
            </box>
        </box>
        <box class="card-secondary-info">
            <box class="card-status">
                <span class="lbl">Status</span>
                <span class="status-text {{selectableData?.status.toUpperCase()}}">{{ selectableData?.status }}</span>
            </box>
            <box class="h-seperator">&nbsp;</box>
            <box class="valid-thru">
                <span class="lbl">Valid thru</span>
                <span class="amount">{{ selectableData?.validThru }}</span>
            </box>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #accountSummaryCardTmplt [appControlTemplate]="'accountSummaryCardTmplt'">
    <box class="card-body account-card-body">
        <box class="card-primary-info">
            <box class="logo">
                <img src="./assets/images/bank-brand.svg" alt="account">
            </box>
            <box class="account-reference-details">

                <h3>{{ selectableData?.nickName || selectableData?.accountTypeDesc }}</h3>
                <span class="acc-info">{{ selectableData?.accountNumber }}</span>
            </box>
         <box class="logo-share">
          <button type="button" class="btn-share" (click)="shareAccountInfo($event,selectableData)"><span>Share</span></button>
         </box>
          </box>
        <box class="card-secondary-info">
            <box class="actual-balance">
                <span class="amount">{{ selectableData?.actualBalance | currency : selectableData?.currency : '' }}&nbsp;<em>{{ selectableData?.accountCurrency  }}</em> </span>
            </box>
            <box class="hold-balance">
                <span class="lbl">Hold Balance</span>
                <span class="amount">{{ selectableData?.holdBalance | currency : selectableData?.currency : '' }}&nbsp;<em>{{ selectableData?.accountCurrency  }}</em></span>
            </box>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #depositSummaryCardTmplt [appControlTemplate]="'depositSummaryCardTmplt'">
    <box class="card-body deposit-card-body">
        <box class="card-primary-info">
            <box class="logo">
                <img src="./assets/images/icons/deposits.svg" alt="deposits" />
            </box>
            <box class="deposit-reference-details">

                <h3>{{selectableData?.productDesc }}</h3>
                <span class="acc-info">{{selectableData?.accountDetails?.length}} Active GICs</span>
            </box>
        </box>
        <box class="card-secondary-info">
            <span class="lbl">Principal Amount</span>
            <span class="amount">{{ selectableData?.totalDepositAmount | currency : selectableData?.accountDetails[0].currency : '' }}&nbsp;<em>{{ selectableData?.accountDetails[0].currency  }}</em></span>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #loanSummaryCardTmplt [appControlTemplate]="'loanSummaryCardTmplt'">
    <box class="card-body loan-card-body">
        <box class="card-primary-info">
            <box class="logo">
                <img src="./assets/images/icons/loan-disbursal.svg" alt="loans" />
            </box>
            <box class="loan-reference-details">
                <h3>{{ selectableData?.accountNumber }}</h3>
                <span class="acc-info">{{ selectableData?.nickName || selectableData?.productDesc }}</span>
            </box>
        </box>
        <box class="card-secondary-info">
            <span class="lbl">Outstanding Amount</span>
            <span class="amount">{{ selectableData?.outstandingAmount | currency : selectableData?.currency : '' }}&nbsp;<em>{{ selectableData?.currency  }}</em></span>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #creditSummaryCardTmplt [appControlTemplate]="'creditSummaryCardTmplt'">
    <box class="card-body credit-card-body">
        <span class="card-category">Credit</span>
        <box class="card-primary-info">
            <box class="logo">
                <img src="./assets/images/icons/credit-card.svg" alt="credit-card" />
            </box>
            <box class="card-reference-details">
                <h3>{{ selectableData?.cardNumber }}</h3>
                <box class="card-type">
                    <span class="card-type-name">{{ selectableData?.productDesc }}</span>
                    <span class="card-type-logo">
                        <img src="./assets/images/cards-logo/{{ selectableData?.cardType.toLocaleLowerCase() }}.svg"
                            alt="{{ selectableData?.cardType }}" />
                    </span>
                </box>
            </box>
        </box>
        <box class="card-secondary-info">
            <box class="available-limits">
                <span class="lbl">Available limits</span>
                <span class="amount">{{ selectableData?.availableCreditLimit | currency : selectableData?.currency : '' }}&nbsp;<em>{{ selectableData?.currency  }}</em></span>
            </box>
            <box class="h-seperator">&nbsp;</box>
            <box class="outstanding">
                <span class="lbl">Outstanding</span>
                <span class="amount">{{ selectableData?.outstandingAmount | currency : selectableData?.currency : '' }}&nbsp;<em>{{ selectableData?.currency  }}</em></span>
            </box>
        </box>
    </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #chequeStatusEnquiryResult
    [appControlTemplate]="'chequeStatusEnquiryResult'">
    <box class="trx-item">
        <box class="tx-icon">
            <img src="./assets/images/icons/cheque.svg" alt="cheque" />
        </box>
        <box class="trx-details">
            <span class="issue-date">{{item?.issueDate}}</span>
                <span class="customer-name">{{item?.customerName}}</span>
                <span class="cheque-number">{{item?.chequeNumber}}</span>
                <div class="status">{{item?.status}}</div>
        </box>
    </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #loanDisbursalTmplt
    [appControlTemplate]="'loanDisbursalTmplt'">

    <div class="loan-disbursal-wrapper">
        <div class="header">
            <div class="icon">
                {{ item.transactionDesc.charAt(0).toUpperCase() }}
            </div>
            <div class="content">
                <span class="content-date">{{ item.transactionDate }}</span>
                <span class="content-title">{{ item.transactionDesc }}</span>
                <span class="content-date">{{ item.transactionRemarks }}</span>
            </div>
        </div>
        <div class="footer">
            <div class="tag">
                <span class="tag-content">{{ item.transactionCat }}</span>
            </div>
            <div class="footer-currency">
                <span class="footer-currency-amount">+{{ item.transactionAmount }}</span>&nbsp;
                <span class="footer-currency-code"> {{ item.transactionCurrency }}</span>
            </div>
        </div>
    </div>
</ng-template>